<template>
  <require from="framework/value_converters/date-and-time"></require>

  <table class="table table-borderless table-striped sc-table-fixed">
    <thead>
      <tr>
        <th width="200px">Change</th>
        <th width="200px" class="d-none d-lg-table-cell">Approver</th>
        <th>Description</th>
        <th width="29px"></th>
      </tr>
    </thead>
    <tbody>
      <tr repeat.for="record of history">
        <td>
          <span title="${record.createdOn | dateTime}">${record.createdOn | dateTime}</span><br />
          <span class="text-muted" title="by ${record.createdBy.name}">by ${record.createdBy.name}</span>
        </td>
        <td class="d-none d-lg-table-cell">
          <span title="${record.approver.name}">${record.approver.name}</span><br />
          <span class="text-muted" title="${record.country.name}">${record.country.name}</span>
        </td>
        <td title="${record.comment}">
          <div class="sc-line-clamp-2">
            <span class="at-approval-status ${record.approvalStatusClass}" if.bind="record.approvalStatus">${record.approvalStatus.name}${record.comment ? ':' : ''}</span>
            <span if.bind="record.comment" class="${record.approver ? 'text-muted font-italic' : ''}">${record.comment}</span>
          </div>
        </td>
        <td title="${record.requestStatus.name}">
          <i class="ai-approval-status ${record.requestStatusClass}"></i>
        </td>
      </tr>
    </tbody>
  </table>
</template>
